// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__vfogQ","card":"Cards_card__HDM9Z","infected":"Cards_infected__YyOHQ","recovered":"Cards_recovered__5sTfr","deaths":"Cards_deaths__ZnoLb"};